import {createRoute} from '@/velta/components/crud';
import {createRoute as createRouteFilter} from '@/velta/components/filter';
import routesImportador from "@/router/importadorRoutes";

// Definimos as rotas da empresa

const routes = [
    {
        path: "/sistema/empresa/excluir-conta",
        name: "excluir-conta",
        component: () => import("@/views/empresa/ExcluirConta.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Excluir a minha conta",
        },
    },
    {
        path: "/sistema/empresa/login-geral",
        name: "login-geral",
        component: () => import("@/views/empresa/LoginGeral.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Acessar Sistema",
        },
    },
    {
        // Resposta ao convite de vínculo, aberta pelo link do e-mail. Pública:
        // o token é a credencial, e quem responde pode nem estar logado.
        path: "/sistema/empresa/convite",
        name: "convite-vinculo",
        component: () => import("@/views/auth/Convite.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Confirmar Acesso",
        },
    },
    {
        // Destino do link enviado por e-mail na recuperação de senha. Pública:
        // quem chega aqui, por definição, não consegue entrar.
        path: "/sistema/empresa/definir-senha",
        name: "definir-senha",
        component: () => import("@/views/auth/DefinirSenha.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Definir Senha",
        },
    },
    {
        // Escolha de conta, exibida DEPOIS da senha quando o e-mail tem 2+
        // contas. Fica fora de /sistema/cliente de propósito: quem chega aqui
        // ainda não escolheu a área, e o destino final é sempre uma recarga
        // completa para a área certa.
        path: "/sistema/empresa/selecionar-perfil",
        name: "selecionar-perfil",
        component: () => import("@/views/auth/SelecionarPerfil.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Selecionar Conta",
        },
    },
    {
        path: "/sistema/empresa/parceiros-veltacar",
        name: "parceiros-veltacar",
        component: () => import("@/views/empresa/ParceirosVeltaCar.vue"),
        meta: {
            pageTitle: "Parceiros VeltaCar",
            resource: "any",
            breadcrumb: [
                {
                    text: "Parceiros VeltaCar",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta",
        name: "adminvelta",
        component: () => import("@/views/empresa/AdminVelta.vue"),
        meta: {
            pageTitle: "Admin Velta",
            resource: "ADMINVELTA",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/adminvelta/nps-insights",
        name: "adminvelta-nps-insights",
        component: () => import("@/views/admin/NPSInsights.vue"),
        meta: {
            pageTitle: "Dashboard NPS",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                {
                    text: "Admin Velta",
                    to: { name: "adminvelta" },
                },
                {
                    text: "Dashboard NPS",
                    active: true,
                },
            ],
        },
    },
    // CRM Routes
    {
        path: "/sistema/empresa/adminvelta/crm",
        name: "adminvelta-crm",
        component: () => import("@/views/empresa/adminveltacrm/Dashboard.vue"),
        meta: {
            pageTitle: "CRM",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/entidades/:id",
        name: "adminvelta-crm-entidade-detail",
        component: () => import("@/views/empresa/adminveltacrm/EntidadeDetail.vue"),
        meta: {
            pageTitle: "Detalhe da Entidade",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Detalhe", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/kanban",
        name: "adminvelta-crm-kanban",
        component: () => import("@/views/empresa/adminveltacrm/KanbanView.vue"),
        meta: {
            pageTitle: "Kanban - Jornada do Cliente",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Kanban", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/funil",
        name: "adminvelta-crm-funil",
        component: () => import("@/views/empresa/adminveltacrm/FunilKanbanView.vue"),
        meta: {
            pageTitle: "Kanban Escala Saas",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Kanban Escala Saas", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/templates-oficiais",
        name: "adminvelta-crm-templates-oficiais",
        component: () => import("@/views/empresa/adminveltacrm/TemplatesOficiais.vue"),
        meta: {
            pageTitle: "Templates Oficiais",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Templates Oficiais", active: true },
            ],
        },
    },
    // Campanhas em massa de templates oficiais (WABA)
    {
        path: "/sistema/empresa/adminvelta/crm/campanhas",
        name: "adminvelta-crm-campanhas",
        component: () => import("@/views/empresa/adminveltacampanhas/Index.vue"),
        meta: {
            pageTitle: "Campanhas (API Oficial)",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Campanhas", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/campanhas/nova",
        name: "adminvelta-crm-campanha-nova",
        component: () => import("@/views/empresa/adminveltacampanhas/Form.vue"),
        meta: {
            pageTitle: "Nova Campanha",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Campanhas", to: { name: "adminvelta-crm-campanhas" } },
                { text: "Nova", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/campanhas/:id/duplicar",
        name: "adminvelta-crm-campanha-duplicar",
        component: () => import("@/views/empresa/adminveltacampanhas/Form.vue"),
        meta: {
            pageTitle: "Duplicar Campanha",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Campanhas", to: { name: "adminvelta-crm-campanhas" } },
                { text: "Duplicar", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/campanhas/:id",
        name: "adminvelta-crm-campanha-detalhe",
        component: () => import("@/views/empresa/adminveltacampanhas/Detalhe.vue"),
        meta: {
            pageTitle: "Campanha",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Campanhas", to: { name: "adminvelta-crm-campanhas" } },
                { text: "Detalhe", active: true },
            ],
        },
    },
    // Disparo em Massa de WhatsApp
    {
        path: "/sistema/empresa/adminvelta/disparo-massa",
        name: "adminvelta-disparo-massa",
        component: () => import("@/views/empresa/adminveltadisparomassa/Index.vue"),
        meta: {
            pageTitle: "Disparo em Massa",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Disparo em Massa", active: true },
            ],
        },
    },
    // NFS-e de Cobranças
    {
        path: "/sistema/empresa/adminvelta/nfse-cobrancas",
        name: "adminvelta-nfse-cobrancas",
        component: () => import("@/views/empresa/adminveltanfse/NfseCobrancasList.vue"),
        meta: {
            pageTitle: "NFS-e de Cobranças",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "NFS-e de Cobranças", active: true },
            ],
        },
    },
    // Site Próprio (landing page no domínio do cliente)
    {
        path: "/sistema/empresa/adminvelta/sites-proprios",
        name: "adminvelta-sites-proprios",
        component: () => import("@/views/empresa/adminveltasites/List.vue"),
        meta: {
            pageTitle: "Sites Próprios",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Sites Próprios", active: true },
            ],
        },
    },
    // Saúde do servidor: fila, workers, agendador, disco, memória, Redis e MySQL
    {
        path: "/sistema/empresa/adminvelta/saude-servidor",
        name: "adminvelta-saude-servidor",
        component: () => import("@/views/empresa/adminveltasaude/SaudeServidor.vue"),
        meta: {
            pageTitle: "Saúde do Servidor",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Saúde do Servidor", active: true },
            ],
        },
    },
    // Respostas do ChatBot: perguntas da API v2 e respostas que o robô não entendeu
    {
        path: "/sistema/empresa/adminvelta/chatbot-respostas",
        name: "adminvelta-chatbot-respostas",
        component: () => import("@/views/empresa/adminveltachatbot/Respostas.vue"),
        meta: {
            pageTitle: "Respostas do ChatBot",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Respostas do ChatBot", active: true },
            ],
        },
    },
    // Ativação Turbo: o que cada empresa Turbo já enviou (Google, site, MyAgentic, NFS-e)
    {
        path: "/sistema/empresa/adminvelta/ativacoes-turbo",
        name: "adminvelta-ativacoes-turbo",
        component: () => import("@/views/empresa/adminveltaativacoesturbo/List.vue"),
        meta: {
            pageTitle: "Ativações Turbo",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Ativações Turbo", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/ativacoes-turbo/:empresaId",
        name: "adminvelta-ativacoes-turbo-detalhe",
        component: () => import("@/views/empresa/adminveltaativacoesturbo/Detalhe.vue"),
        meta: {
            pageTitle: "Ativação Turbo",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Ativações Turbo", to: { name: "adminvelta-ativacoes-turbo" } },
                { text: "Detalhe", active: true },
            ],
        },
    },
    // Funil de NPS
    {
        path: "/sistema/empresa/adminvelta/nps-funil",
        name: "adminvelta-nps-funil",
        component: () => import("@/views/empresa/adminveltanps/Index.vue"),
        meta: {
            pageTitle: "Funil de NPS",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Funil de NPS", active: true },
            ],
        },
    },
    // Replicação de Dados Entre Filiais
    {
        path: "/sistema/empresa/adminvelta/replicacao",
        name: "adminvelta-replicacao",
        component: () => import("@/views/empresa/adminveltareplicacao/Index.vue"),
        meta: {
            pageTitle: "Replicação Filiais",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/replicacao/nova",
        name: "adminvelta-replicacao-form",
        component: () => import("@/views/empresa/adminveltareplicacao/Form.vue"),
        meta: {
            pageTitle: "Nova Replicação",
            resource: "ADMINVELTA",
            action: "create",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", to: { name: "adminvelta-replicacao" } },
                { text: "Nova", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/replicacao/execucoes/:id",
        name: "adminvelta-replicacao-execucao",
        component: () => import("@/views/empresa/adminveltareplicacao/ExecucaoDetail.vue"),
        meta: {
            pageTitle: "Execução",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", to: { name: "adminvelta-replicacao" } },
                { text: "Execução", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/",
        name: "home-company",
        component: () => import("@/views/empresa/Home.vue"),
        meta: {
            pageTitle: "Página Inicial",
            resource: "any",
            breadcrumb: [
                {
                    text: "Página Inicial",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/dashboardfinanceiro",
        name: "dashboardfinanceiro",
        component: () => import("@/views/empresa/DashboardFinanceiro.vue"),
        meta: {
            pageTitle: "Dashboard Financeiro",
            // A própria página já exibe o título "Dashboard Financeiro" junto
            // da saudação. Mantemos o pageTitle apenas para o título da aba do
            // navegador e escondemos a barra de breadcrumb, que repetia o mesmo
            // texto mais duas vezes na tela.
            hideBreadcrumb: true,
            resource: "DASH_FINANCEIRO",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/dashboardservicos",
        name: "dashboardservicos",
        component: () => import("@/views/empresa/DashboardServicos.vue"),
        meta: {
            pageTitle: "Dashboard Serviços",
            resource: "DASH_SERVICOS",
            action: "read",
            breadcrumb: [
                {
                    text: "Dashboard Serviços",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/painel-tv",
        name: "painel-tv",
        component: () => import("@/views/empresa/painelTv/Index.vue"),
        meta: {
            pageTitle: "Painel TV",
            resource: "TAR_ORDENSDESERVICO",
            action: "read",
            layout: "full",
        },
    },
    {
        // Cadastros de apoio que saíram da sidebar (16 itens). `resource: "any"`
        // porque canNavigate não faz OR de vários recursos — a própria página
        // filtra card a card e mostra empty-state se o usuário não tiver nenhum.
        path: "/sistema/empresa/cadastros-administrativos",
        name: "cadastros-administrativos",
        component: () =>
            import("@/views/empresa/cadastrosAdministrativos/Index.vue"),
        meta: {
            pageTitle: "Cadastros Administrativos",
            resource: "any",
            breadcrumb: [{ text: "Cadastros Administrativos", active: true }],
        },
    },
    {
        path: "/sistema/empresa/cadastroempresa",
        name: "cadastroempresa",
        component: () =>
            import("@/views/empresa/cadastroEmpresa/CadastroEmpresa.vue"),
        meta: {
            pageTitle: "Cadastrar Empresa",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/buscador/:estado?/:cidade?/:servico?",
        name: "buscador",
        component: () => import("@/views/empresa/buscador/Index.vue"),
        meta: {
            pageTitle: "Buscador de Empresa",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/configuracoes",
        name: "configuracoes-company",
        component: () => import("@/views/empresa/configuracoes/Form.vue"),
        meta: {
            resource: "CAD_CONFIGURACOES",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/chatbot",
        name: "chatbot-config-company",
        component: () => import("@/views/empresa/chatbot/Form.vue"),
        meta: {
            pageTitle: "ChatBot",
            breadcrumb: [
                { text: "Configurações do ChatBot", active: true },
            ],
            resource: "CONF_CHATBOT",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/marketing",
        name: "marketing",
        component: () => import("@/views/empresa/marketing/Index.vue"),
        meta: {
            pageTitle: "Marketing",
            breadcrumb: [
                { text: "Marketing", active: true },
            ],
            resource: "CAD_CONFIGURACOES",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/site-proprio",
        name: "siteproprio",
        component: () => import("@/views/empresa/siteproprio/Index.vue"),
        meta: {
            pageTitle: "Meu Site Próprio",
            breadcrumb: [
                { text: "Meu Site Próprio", active: true },
            ],
            resource: "CONF_SITE_PROPRIO",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/google-meu-negocio",
        name: "googlemeunegocio",
        component: () => import("@/views/empresa/googleMeuNegocio/Index.vue"),
        meta: {
            pageTitle: "QR Code de Avaliação do Google",
            breadcrumb: [
                { text: "Google Meu Negócio", active: true },
            ],
            resource: "CONF_GOOGLE_MEU_NEGOCIO",
            action: "read",
        },
    },
    {
        // Boas-vindas do Completo Turbo. A tela também barra quem não é
        // administrador da empresa (perfil_id 1); a API usa a gate turbo-admin.
        path: "/sistema/empresa/ativacao-turbo",
        name: "ativacao-turbo",
        component: () => import("@/views/empresa/ativacaoTurbo/Index.vue"),
        meta: {
            pageTitle: "Ativação Turbo",
            breadcrumb: [{ text: "Ativação Turbo", active: true }],
            resource: "CONF_SITE_PROPRIO",
            action: "read",
        },
    },
    {
        // Formulário próprio removido: a credencial virou única e o
        // formulário vive em `login-geral`, que também é o start_url do PWA.
        // A rota fica como ponte por causa de links salvos e do `next()` do
        // guard de rota.
        path: "/sistema/empresa/login",
        name: "login-company",
        component: () => import("@/views/auth/RedirecionarParaLoginGeral.vue"),
        meta: {
            pageTitle: "Acessar Sistema",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/esqueciminhasenha",
        name: "esqueciminhasenha-company",
        component: () => import("@/views/empresa/ForgotPassword.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/termodeuso",
        name: "termodeuso",
        component: () => import("@/views/empresa/TermoDeUso.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/politicaprivacidade",
        name: "politicaprivacidade",
        component: () =>
            import("@/views/empresa/PoliticaDePrivacidadeDeDados.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/nao-autorizado",
        name: "naoAutorizado",
        component: () => import("@/views/empresa/NaoAutorizado.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/plano-bloqueado",
        name: "planoBloqueado",
        component: () => import("@/views/empresa/PlanoBloqueado.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/error-404",
        name: "error-404",
        component: () => import("@/views/empresa/error/Error404.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/planosepagamentos",
        name: "planosepagamentos",
        component: () => import("@/views/empresa/planosepagamentos/List.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/planosepagamentos/cartao",
        name: "planosepagamentos-cartao",
        component: () => import("@/views/empresa/planosepagamentos/Cartao.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/faq",
        name: "faq",
        component: () => import("@/views/empresa/faq/Index.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/indicacao",
        name: "indicacao",
        component: () => import("@/views/empresa/indicacao/Index.vue"),
        meta: {
            pageTitle: "Indicação",
            resource: "any",
            breadcrumb: [
                {
                    text: "Indicação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/indicacoes",
        name: "adminvelta-indicacoes",
        component: () =>
            import("@/views/empresa/adminveltaindicacoes/Index.vue"),
        meta: {
            pageTitle: "Gestão de Indicações",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                {
                    text: "Admin Velta",
                    to: { name: "adminvelta" },
                },
                {
                    text: "Gestão de Indicações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/ordemservico",
        name: "ordemservico",
        component: () => import("@/views/empresa/ordemservico/Index.vue"),
        meta: {
            resource: "TAR_ORDENSDESERVICO",
            action: "read",
            navActiveLink: "ordemservico",
        },
    },
    {
        path: "/sistema/empresa/estoque/dashboard",
        name: "estoquedashboard",
        component: () => import("@/views/empresa/estoque/Dash.vue"),
        meta: {
            resource: "CAD_ESTOQUE",
            action: "read",
            navActiveLink: "estoque",
        },
    },
    {
        path: "/sistema/empresa/consumo-fracionado",
        name: "consumofracionado",
        component: () => import("@/views/empresa/consumofracionado/Dashboard.vue"),
        meta: {
            resource: "CAD_ESTOQUE",
            action: "read",
            pageTitle: "Consumo Fracionado",
            navActiveLink: "estoque",
        },
    },
    {
        path: "/sistema/empresa/configuracoes-iniciais",
        name: "initialConfiguration",
        component: () =>
            import("@/views/empresa/configuracoesIniciais/Index.vue"),
        meta: {
            pageTitle: "Configurações Iniciais",
            resource: "any",
            breadcrumb: [
                {
                    text: "Configurações Iniciais",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/onboarding",
        name: "onboarding",
        component: () => import("@/views/empresa/onboarding/Index.vue"),
        meta: {
            layout: "onboarding",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/whatsapp-suporte",
        name: "initialConfigurationWhatsappSuporte",
        component: () =>
            import("@/views/empresa/configuracoesIniciais/WhatsAppSuporte.vue"),
        meta: {
            pageTitle: "Configurações Iniciais",
            resource: "any",
            breadcrumb: [
                {
                    text: "Configurações Iniciais",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/black-veltacar",
        name: "blackPromotion",
        component: () => import("@/views/empresa/promotion/Black.vue"),
        meta: {
            pageTitle: "BlackVeltacar",
            resource: "any",
            breadcrumb: [
                {
                    text: "BlackVeltacar",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/versions",
        name: "versions",
        component: () => import("@/views/empresa/Versions.vue"),
        meta: {
            pageTitle: "Histórico de Versões",
            resource: "any",
            breadcrumb: [
                {
                    text: "Histórico de Versões",
                    active: true,
                },
            ],
        },
    },
    ...routesImportador,
    ...createRoute("Empresas", "adminveltaempresas", "ADMINVELTA"),
    ...createRoute("Usuários Auto-Agendamento", "adminveltaclientesgerais", "ADMINVELTA"),
    ...createRoute("Planos", "adminveltaplanos", "ADMINVELTA"),
    ...createRoute("Blog", "adminveltaposts", "ADMINVELTA"),
    ...createRoute("Notificacoes", "adminveltanotificacoes", "ADMINVELTA"),
    ...createRoute("Vídeo Aulas", "adminveltavideoaulas", "ADMINVELTA"),
    ...createRoute("Usuários", "usuario", "CAD_USUARIOS"),
    ...createRoute(
        "Modalidade de Entrega",
        "modalidade",
        "CAD_MODALIDADES",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Controle de Caixa",
        "controlecaixa",
        "TAR_CONTROLECAIXA",
        "Operacionais",
        true,
        true
    ),
    ...createRoute(
        "Serviços",
        "servico",
        "CAD_SERVICOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Categorias de Serviço",
        "categoria-servico",
        "CAD_SERVICOS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute("Perfis", "perfil", "CAD_PERFIS"),
    ...createRoute("Vagas", "vaga", "CAD_VAGAS", "Cadastros", true, true),
    ...createRoute(
        "Orçamentos",
        "orcamento",
        "TAR_ORCAMENTOS",
        "Operacionais",
        true,
        true
    ),
    ...createRoute("Recibos", "recibo", "TAR_RECIBOS"),
    ...createRoute(
        "Sugestão de Melhoria",
        "sugestaomelhoria",
        "CAD_SUGESTAOMELHORIA"
    ),
    ...createRoute("Clientes", "cliente", "CAD_CLIENTES"),
    ...createRoute(
        "Nota Fiscal",
        "notafiscal",
        "TAR_NOTAFISCAL",
        "Operacionais"
    ),
    ...createRoute(
        "Convênios/Assinaturas",
        "convenio",
        "CAD_CONVENIOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Pacotes",
        "pacote",
        "CAD_PACOTES",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Tamanhos de Veículo",
        "tamanho-veiculo",
        "CAD_TAMANHOSVEICULO",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Comissões",
        "comissao",
        "CAD_COMISSAO",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Funcionários",
        "funcionario",
        "CAD_FUNCIONARIOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Profissões",
        "profissao",
        "CAD_PROFISSOES",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Produtos/Peças",
        "produto",
        "CAD_PRODUTOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Grupos de Estoque",
        "grupoestoque",
        "CONF_ESTOQUEINDIVIDUALIZADOPORCONCESSIONARIAS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Venda de Produtos/Peças",
        "venda",
        "CAD_VENDAPRODUTOS",
        "Operacionais"
    ),
    ...createRoute(
        "Entradas Estoque",
        "estoque",
        "CAD_ESTOQUE",
        "Operacionais"
    ),
    ...createRoute("NFe Entrada", "nfeentrada", "NFE_ENTRADA", "Operacionais"),
    ...createRoute("Fornecedores", "fornecedor", "CAD_FORNECEDOR", "Cadastros"),
    ...createRoute(
        "Empresa Cliente",
        "empresaCliente",
        "CONF_MODELO_CONCESSIONARIA|CONF_AUTOAGENDAMENTOPREENCHEREMPRESA",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Formas de Pagamento",
        "formasdepagamentos",
        "CAD_FORMASDEPAGAMENTOS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Maquininhas de Cartão",
        "maquininha",
        "CAD_MAQUININHAS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Checklist Modelo",
        "itemchecklistmodelo",
        "CAD_ITEM_MODELO_CHECKLIST",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Categorias de Caixa",
        "controlecaixacategoria",
        "CAD_CONTROLE_CAIXA_CATEGORIA",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Programa de Fidelidade",
        "programafidelidade",
        "CAD_FIDELIDADE",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Recompensas Fidelidade",
        "recompensafidelidade",
        "CAD_FIDELIDADE",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Categorias de Patrimônio",
        "patrimonio-categoria",
        "CAD_PATRIMONIO",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Patrimônio",
        "patrimonio",
        "CAD_PATRIMONIO",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Contas Bancárias",
        "contabancaria",
        "CAD_CONTABANCARIA",
        "Cadastros",
        false,
        false
    ),
    ...createRouteFilter("Estoque", "RelatorioEstoque", "REL_ESTOQUE"),
    ...createRouteFilter("Produtos a Vencer", "ProdutosAVencer", "REL_ESTOQUE"),
    ...createRouteFilter(
        "Relatório de Venda de Produtos/Peças",
        "RelatorioVenda",
        "REL_VENDA"
    ),
    ...createRouteFilter("Clientes", "RelatorioCliente", "CAD_CLIENTES"),
    ...createRouteFilter("Frequência de Clientes", "ClienteFrequente", "CAD_CLIENTES"),
    ...createRouteFilter("Caixa", "Caixa", "REL_CAIXA"),
    ...createRouteFilter("Contas a Pagar", "ContasAPagar", "REL_CONTASAPAGAR"),
    ...createRouteFilter(
        "Aniversariantes",
        "Aniversariante",
        "REL_ANIVERSARIANTES"
    ),
    ...createRouteFilter(
        "Serviços Realizados",
        "ServicoRealizado",
        "REL_SERVICOSREALIZADOS"
    ),
    ...createRouteFilter("Convênios", "RelatorioConvenio", "REL_CONVENIOS"),
    ...createRouteFilter(
        "Serviços Pos-Venda Clientes",
        "ServicoPosVendaCliente",
        "REL_SERVICOSPOSVENDACLIENTES"
    ),
    ...createRouteFilter(
        "Comissões",
        "RelatorioComissao",
        "REL_COMISSAO"
    ),
    ...createRouteFilter("Patrimônio", "RelatorioPatrimonio", "REL_PATRIMONIO"),

    // DRE - Demonstração do Resultado
    {
        path: "/sistema/empresa/dre",
        name: "dre",
        component: () => import("@/views/empresa/Dre.vue"),
        meta: {
            pageTitle: "DRE - Demonstração do Resultado",
            resource: "REL_DRE",
            action: "read",
            breadcrumb: [
                {
                    text: "Relatórios",
                    active: false,
                },
                {
                    text: "DRE",
                    active: true,
                },
            ],
        },
    },

    // Integrações e Automações
    {
        path: "/sistema/empresa/integracoes",
        name: "integracoes",
        component: () => import("@/views/empresa/integracoes/Index.vue"),
        meta: {
            pageTitle: "Integrações",
            resource: "INT_INTEGRACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes",
        name: "automacao",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/List.vue"),
        meta: {
            pageTitle: "Automações",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/c",
        name: "automacaoCreate",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Nova Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "create",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Nova Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/r/:id",
        name: "automacaoRead",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Visualizar Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Visualizar Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/u/:id",
        name: "automacaoUpdate",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Editar Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "update",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Editar Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/:id/logs",
        name: "automacaoLogs",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Logs.vue"),
        meta: {
            pageTitle: "Histórico de Envios",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Histórico de Envios",
                    active: true,
                },
            ],
        },
    },
];

export default routes;
